import styled from 'styled-components';

export const StyledPpeDistribution = styled.div`
  width: 100%;
  max-height: 60vh;
  min-height: 795px;
  overflow-y: auto;
  padding: 24px 28px;

  .pd-wrapper {
    margin-bottom: 16px;

    .ba-label {
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      min-width: 82px !important;
      margin-bottom: 0 !important;
    }
  }

  .pd-table {
    margin-top: 56px;

    > div {
      > .MuiTableContainer-root {
        min-height: calc(360px - 60px);
        max-height: calc(360px - 60px);
      }
    }
  }

  .pd-footer {
    display: flex;
    justify-content: flex-end;
    padding: 28px 0;
    gap: 12px;

    > button {
      width: auto;
    }
  }
`;

export const StyledInfoBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;

  > div {
    width: 50%;
    margin-bottom: 0;
  }
`;
